module.exports = __webpack_public_path__ + "img/IMG_3945_L_Foamcore_MockedUp.9dd842ea.jpg";